export default __webpack_public_path__ + "static/media/lobby-hover.fae318c7.png";